import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Heading } from '@/components/layout/Heading';
import type { Platform } from '@/lib/db';
import { fadeUp } from '@/lib/motion';
import { PlatformIcon } from './PlatformIcon';

interface RequirementListProps {
  headline: string;
  items: readonly string[];
  icon: Platform;
}

export function RequirementList({ headline, items, icon }: RequirementListProps) {
  return (
    <motion.div
      variants={fadeUp}
      className="flex flex-col gap-4 rounded-2xl border border-border bg-card p-6 shadow-soft"
    >
      <div className="flex items-center gap-3">
        <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary-soft text-brand">
          <PlatformIcon platform={icon} className="h-4 w-4" />
        </span>
        <Heading level={4} as="h3">
          {headline}
        </Heading>
      </div>
      <ul className="flex flex-col gap-2">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-2 text-sm text-muted-foreground">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </motion.div>
  );
}
